import React from "react";
import SelectService from "../../components/SelectService";

const Server1 = () => {

  return (
    <>
      <SelectService server={'1'}  />
    </>
  );
};

export default Server1;
